function initStoreAvailabilityDrawer() {

  const drawer = document.querySelector('[data-store-availability-drawer]');
  const openButton = document.querySelector('[data-store-availability-open]');
  const closeButtons = document.querySelectorAll('[data-store-availability-close]');

  if (!drawer || !openButton) return;

  if (openButton.dataset.listenerAdded === 'true') return;

  openButton.dataset.listenerAdded = 'true';

  openButton.addEventListener('click', () => {
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  });

  closeButtons.forEach((button) => {
    button.addEventListener('click', () => {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  });

}

document.addEventListener('DOMContentLoaded', initStoreAvailabilityDrawer);

document.addEventListener('shopify:section:load', initStoreAvailabilityDrawer);

document.addEventListener('change', () => {
  setTimeout(() => {
    initStoreAvailabilityDrawer();
  }, 300);
});